import { render, staticRenderFns } from "./ehc-admin-drawer.vue?vue&type=template&id=d90ad2e8"
import script from "./ehc-admin-drawer.vue?vue&type=script&lang=js"
export * from "./ehc-admin-drawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports